module.exports = __webpack_public_path__ + "54c0c5ee91effc82efb62560fd4271a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_65.jpg
// module id = 1753
// module chunks = 5